import {
  MAIN_URL,
  PORT_FOR_AUTH,
  API_REFRESH_ACCESS_TOKEN,
  API_REFRESH_REFRESH_TOKEN,
} from "../../constants/constants";
import {
  REFRESH_ACCESS_TOKEN,
  REFRESH_REFRESH_TOKEN,
  REFRESH_REFRESH_TOKEN_ERROR,
} from "../types";
import Cookies from "js-cookie";
import { setLoginStatus } from "./actionLogin";

export const actionRefreshToken = () => {
  const refreshToken = Cookies.get("refreshToken");
  return async (dispatch) => {
    const response = await fetch(
      MAIN_URL + PORT_FOR_AUTH + API_REFRESH_ACCESS_TOKEN,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken: refreshToken }),
      },
    ).catch((err) => console.error(err));

    if (response.ok) {
      const data = await response.json();

      const currentTime = new Date();
      const expirationTime = new Date(currentTime.getTime() + 4 * 60 * 1000);

      Cookies.set("accessToken", data.accessToken, {
        expires: expirationTime,
      });

      dispatch({
        type: REFRESH_ACCESS_TOKEN,
        data: data,
      });
    }

    if (!response.ok) {
      dispatch({
        type: REFRESH_REFRESH_TOKEN_ERROR,
        data: "Вход с другого устройства",
      });
      Cookies.remove("refreshToken");
      Cookies.remove("accessToken");
    }
  };
};

export const actionRefreshRefreshToken = () => {
  const refreshToken = Cookies.get("refreshToken");
  return async (dispatch) => {
    const response = await fetch(
      MAIN_URL + PORT_FOR_AUTH + API_REFRESH_REFRESH_TOKEN,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken: refreshToken }),
      },
    ).catch((err) => console.error(err));

    if (response.ok) {
      const data = await response.json();

      const currentTime = new Date();
      const refreshTokenTime = new Date(
        currentTime.getTime() + 1440 * 60 * 1000,
      );
      const accessTokenTime = new Date(currentTime.getTime() + 4 * 60 * 1000);

      Cookies.set("accessToken", data.accessToken, {
        expires: accessTokenTime,
      });
      Cookies.set("refreshToken", data.refreshToken, {
        expires: refreshTokenTime,
      });

      dispatch(setLoginStatus(true));

      dispatch({
        type: REFRESH_REFRESH_TOKEN,
        data: data,
      });
      dispatch({
        type: REFRESH_REFRESH_TOKEN_ERROR,
        data: "",
      });
    }

    if (!response.ok) {
      dispatch({
        type: REFRESH_REFRESH_TOKEN_ERROR,
        data: "Ошибка сервера",
      });
      Cookies.remove("refreshToken");
      Cookies.remove("accessToken");
    }
  };
};

export const actionResetTokenError = () => {
  return async (dispatch) => {
    dispatch({
      type: REFRESH_REFRESH_TOKEN_ERROR,
      data: "",
    });
  };
};
